<template>
<div class="chapter">
<div class="inner_page">
<h3 class="BHD"><strong>STITCH, CRAFT, CREATE:</strong></h3>
<h2 class="AHD"><strong>Cake Decorating</strong></h2>
<p class="BOD1">Various Authors</p>
<div class="Image"><img alt="" src="OEBPS/images/logo.gif"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?1374ea94